import { ToastAction, ToastType, useToastsDispatch } from '@bechtel/gds';
import { encodeUrl, i18next as i18n } from '@bechtel/ht-clients-common';
import { CreateUserAccountInput, Role } from '@bechtel/ht-types';
import { Formik, FormikProps } from 'formik';
import { FC } from 'react';
import { useCreateUser } from '~/hooks/use-create-user';
import { UserDetailContainerStyled } from '../detail/styled';
import { editUserValidationSchema, initialValues, initialValuesProps, UserDetailsProps } from '../detail/types';
import { UserInfoDetail } from '../detail/user-info-detail';

export const CreateUser: FC<UserDetailsProps> = ({ rolePermissionList }) => {
  const dispatchToast = useToastsDispatch();
  const { createUserAccount, loading: createUserLoading } = useCreateUser();
  //We can enable this if required.As discussed with Sid this should not be mandatory field
  // const updatedSchemaValidation = editUserValidationSchema.shape({
  //   toolRooms: array().when('roles', {
  //     is: (roles) => checkToolRoomsRoles(roles, rolePermissionList),
  //     then: (schema) => schema.min(1, 'Select at least 1 tool room'),
  //     otherwise: (schema) => schema.min(0),
  //   }),
  // });
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={editUserValidationSchema}
      onSubmit={async (values: initialValuesProps) => {
        const userData: CreateUserAccountInput = {
          roleIds: values?.roles?.map((item: Role) => item.id) ?? [],
          isActive: values.isActive,
          persona: values.persona,
          nameFirst: values.firstName,
          nameLast: values.lastName,
          bun: values.bun,
          lobEmployeeId: values.lobEmployeeId,
          upn: values.upn ? encodeUrl(values.upn) : values.upn,
          exemptedFromImport: values.exemptedFromImport,
        };
        if (values.supervisorId) {
          userData.supervisorId = values.supervisorId;
        }
        createUserAccount(
          userData,
          (data) => {
            const adhocOrderCreationToast: ToastAction = {
              type: 'ADD_TOAST',
              payload: {
                toastType: data.error ? ToastType.DANGER : ToastType.SUCCESS,
                content: data.error ? i18n.t(data.error) : `User added successfully`,
                autoDismissTimeout: 3000,
              },
            };
            dispatchToast(adhocOrderCreationToast);
          },
          (error) => {
            const adhocOrderCreationToast: ToastAction = {
              type: 'ADD_TOAST',
              payload: {
                toastType: ToastType.DANGER,
                content: i18n.t('COMMON_ERROR_MESSAGE'),
                autoDismissTimeout: 3000,
              },
            };
            dispatchToast(adhocOrderCreationToast);
          }
        );
      }}
    >
      {(formikProps: FormikProps<initialValuesProps>) => {
        return (
          <UserDetailContainerStyled pl={{ sm: '450' }} pr={{ sm: '500' }}>
            <UserInfoDetail
              userDetail={null}
              mutationLoading={createUserLoading}
              formikProps={formikProps}
              rolePermissionList={rolePermissionList}
            />
          </UserDetailContainerStyled>
        );
      }}
    </Formik>
  );
};
